import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";
import { Options } from "./SelectOptions";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    academicTitle: string,
    becomingAwareThrough: string,
    becomingAwareThroughOther: string,
    applicationLink: string,
    additionalConsent: CheckboxField[],
    entranceDate: Date | null,
    // Zusatzdokumente
    letterFile: File | undefined,
    schoolDiplomaFile: File | undefined,
    applicantPhotoFile: File | undefined,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    academicTitle: string = "";
    becomingAwareThrough: string = "";
    becomingAwareThroughOther: string = "";
    applicationLink: string = "";
    entranceDate: Date | null = null;
    letterFile: File | undefined = undefined;
    schoolDiplomaFile: File | undefined = undefined;
    applicantPhotoFile: File | undefined = undefined;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    additionalConsent: CheckboxField[] = Options.AdditionalConsent.map((field) => {
        return new CheckboxField(field.value);
    });

    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "academicTitle", value: this.academicTitle },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughOther", value: this.becomingAwareThroughOther },
            { name: "applicationLink", value: this.applicationLink },
            { name: "additionalConsent", value: this.additionalConsent.filter((field) => field.value === true).map((field) => field.displayName).join(';')},
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
        );

        return application;
    }
}
